// @flow
export const metaVerticalOther = 'publisher.meta.vertical_other';
export const metaPartnerCategory = 'publisher.meta.partner_category';
export const metaPartnerContentFocus = 'publisher.meta.partner_content_focus';
export const metaPartnerToolsFocus = 'publisher.meta.partner_tools_focus';
export const metaPartnerCategoryVertical = 'publisher.meta.partner_category_vertical';
